import { Skeleton } from './Skeleton';

/* ─── CalendarSkeleton ────────────────────────────────────────────── */
export function CalendarSkeleton() {
  return (
    <div className="pb-4">
      {/* Header bar */}
      <div className="px-3 py-2 border-b border-slate-700/50 flex items-center justify-between">
        <Skeleton width={28} height={28} className="rounded-lg" />
        <Skeleton width={120} height={16} className="rounded" />
        <Skeleton width={60} height={28} className="rounded-lg" />
      </div>

      {/* Day-of-week header row */}
      <div className="grid grid-cols-7 gap-1 px-3 pt-3 pb-1">
        {Array.from({ length: 7 }).map((_, i) => (
          <Skeleton key={i} height={12} className="rounded" />
        ))}
      </div>

      {/* 5-row month grid */}
      <div className="grid grid-cols-7 gap-1 px-3">
        {Array.from({ length: 35 }).map((_, i) => (
          <div key={i} className="aspect-square">
            <Skeleton className="w-full h-full rounded-lg" />
          </div>
        ))}
      </div>

      {/* Legend row */}
      <div className="flex items-center gap-3 px-3 pt-3">
        <Skeleton width={60} height={10} className="rounded" />
        <Skeleton width={80} height={10} className="rounded" />
        <Skeleton width={50} height={10} className="rounded" />
      </div>
    </div>
  );
}

/* ─── TimelineSkeleton ────────────────────────────────────────────── */
export function TimelineSkeleton() {
  const widths = ['100%', '85%', '92%', '78%', '95%', '88%'];

  return (
    <div className="flex flex-col gap-2 px-3 pt-3 pb-4">
      {widths.map((w, i) => (
        <Skeleton key={i} width={w} height={48} className="rounded-xl" />
      ))}
    </div>
  );
}

/* ─── OverlapsSkeleton ────────────────────────────────────────────── */
export function OverlapsSkeleton() {
  return (
    <div className="pb-4">
      {/* Header area */}
      <div className="px-3 py-2 border-b border-slate-700/50">
        <Skeleton width={180} height={16} className="rounded" />
        <Skeleton width={140} height={10} className="rounded mt-1.5" />
      </div>

      {/* Overlap cards */}
      <div className="flex flex-col gap-2.5 px-3 pt-2.5">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} height={120} className="w-full rounded-xl" />
        ))}
      </div>
    </div>
  );
}

/* ─── FriendsSkeleton ─────────────────────────────────────────────── */
export function FriendsSkeleton() {
  return (
    <div className="pb-4">
      {/* Header */}
      <div className="px-3 py-2 border-b border-slate-700/50">
        <Skeleton width={80} height={16} className="rounded" />
      </div>

      {/* Search input skeleton */}
      <div className="px-3 pt-2.5">
        <Skeleton height={40} className="w-full rounded-lg" />
      </div>

      {/* Friend cards */}
      <div className="flex flex-col gap-2 px-4 pt-4">
        <Skeleton width={100} height={10} className="rounded mb-1" />
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 py-2">
            <Skeleton width={40} height={40} className="rounded-full shrink-0" />
            <div className="flex-1 flex flex-col gap-1.5">
              <Skeleton width="60%" height={14} className="rounded" />
              <Skeleton width="40%" height={10} className="rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
